// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1oGd0","colLarge":"styles_colLarge__1tT6J","col":"styles_col__2_zxJ","colCheckbox":"styles_colCheckbox__2lG8p","actions":"styles_actions__3f9DN"};